export const STATUS_OPTIONS = [
    {
        label: "Active",
        value: "active"
    }
];